import ReleasePipelineDetail from 'components/release-pipelines/ReleasePipelineDetail'

export default function ReleasePipelineDetailPage() {
  return <ReleasePipelineDetail />
}
